import React, { useState, useEffect } from "react";
import apiClient from "../../AppClient";
import { Container, Table, Alert, Spinner, Card } from "react-bootstrap";

const InventorySummaryReport = () => {
  const [inventorySummary, setInventorySummary] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fetch inventory summary data
  const fetchInventorySummary = async () => {
    setLoading(true);
    try {
      const response = await apiClient.get("/transactions/reports/inventory-summary/");
      setInventorySummary(response.data);
      setError(null);
    } catch (error) {
      setError(error.response?.data?.detail || "فشل في جلب ملخص المخزون.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInventorySummary();
  }, []);

  return (
    <Container style={{ 
      direction: "rtl", 
      textAlign: "right", 
      padding: "20px", 
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      color: "black", 
      backgroundColor: "white" 
    }}>
      <h1 style={{ color: "darkgreen", marginBottom: "20px" }}>تقرير ملخص المخزون</h1>

      {/* Error Message */}
      {error && <Alert variant="danger">{error}</Alert>}

      {/* Loading Spinner */}
      {loading ? (
        <div className="text-center">
          <Spinner animation="border" role="status" style={{ color: "darkgreen" }}>
            <span className="visually-hidden">جاري التحميل...</span>
          </Spinner>
        </div>
      ) : (
        /* Inventory Summary Table */
        <Card style={{ padding: "20px", border: "1px solid darkgreen", borderRadius: "5px" }}>
          <h4 style={{ color: "darkgreen" }}>الملخص المخزني</h4>
          <Table hover responsive>
            <thead style={{ backgroundColor: "darkgreen", color: "white" }}>
              <tr>
                <th>اسم المنتج</th>
                <th>المورد الأخير</th>
                <th>الكمية المتاحة</th>
                <th>إجمالي عمليات الشراء</th>
                <th>إجمالي عمليات البيع</th>
                <th>إجمالي التالف</th>
                <th>آخر نشاط</th>
              </tr>
            </thead>
            <tbody>
              {inventorySummary.length === 0 ? (
                <tr>
                  <td colSpan="7" className="text-center">لا توجد بيانات مخزون متاحة</td>
                </tr>
              ) : (
                inventorySummary.map((item, index) => (
                  <tr key={index}>
                    <td>{item.product_name}</td>
                    <td>{item.last_supplier}</td>
                    <td>{item.quantity_available}</td>
                    <td>{item.total_purchase_count}</td>
                    <td>{item.total_sale_count}</td>
                    <td>{item.total_damage_count}</td>
                    <td>{item.last_activity}</td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </Card>
      )}
    </Container>
  );
};

export default InventorySummaryReport;
